module.exports = [
	{
		"trigger": "enet_event_incident",
		"conditions": [
			{
				"name": "sportId",
				"picker": "enum_picker",
				"data_type": "number",
				"label": "Sport",
				"values": [
					{
						"label": "Any",
						"value": "*"
					},
					{
						"label": "Soccer",
						"value": "1"
					},
					{
						"label": "Handball",
						"value": "20"
					},
					{
						"label": "Basket",
						"value": "23"
					},
					{
						"label": "Tennis",
						"value": "2"
					},
					{
						"label": "Hockey",
						"value": "5"
					}
				]
			},
			{
				"name": "ttId",
				"required": true,
				"picker": "tournament_picker",
				"data_type": "number",
				"label": "Tournament Id",
				"values": [
					{
						"label": "Any",
						"value": "*"
					},
					{
						"label": "ALKA Superliga",
						"value": "46"
					},
					{
						"label": "Premier League",
						"value": "47"
					},
					{
						"label": "Spain Primera",
						"value": "87"
					},
					{
						"label": "Bundesliga",
						"value": "54"
					},
					{
						"label": "UEFA Champions League",
						"value": "42"
					},
					{
						"label": "UEFA Europa League",
						"value": "73"
					},
					{
						"label": "Sweden Allsvenskan",
						"value": "67"
					},
					{
						"label": "Norway Eliteserien",
						"value": "59"
					}
				]
			},
			{
				"name": "eventId",
				"label": "Event ID",
				"picker": "event_by_date_picker",
				"data_type": "number"
			},
			{
				"name": "homeId",
				"picker": "team_picker",
				"data_type": "number",
				"label": "Home team Id"
			},
			{
				"name": "awayId",
				"picker": "team_picker",
				"data_type": "number",
				"label": "Away team Id"
			},
			{
				"name": "incident_type",
				"picker": "enum_picker",
				"data_type": "enum",
				"label": "Incident type",
				"values": [
					{
						"label": "All",
						"value": "*"
					},
					{
						"label": "Goal",
						"value": "goal"
					},
					{
						"label": "Yellow Card",
						"value": "yellow_card"
					},
					{
						"label": "Red Card",
						"value": "red_card"
					},
					{
						"label": "Substitution",
						"value": "substitution"
					},
					{
						"label": "Assist",
						"value": "assist"
					},
					{
						"label": "Goal Cancelled",
						"value": "goal_cancelled"
					}
				]
			}
		]
	},
	{
		"trigger": "enet_event_status",
		"conditions": [
			{
				"name": "sportId",
				"picker": "enum_picker",
				"data_type": "number",
				"label": "Sport",
				"values": [
					{
						"label": "Any",
						"value": "*"
					},
					{
						"label": "Soccer",
						"value": "1"
					},
					{
						"label": "Handball",
						"value": "20"
					},
					{
						"label": "Basket",
						"value": "23"
					},
					{
						"label": "Tennis",
						"value": "2"
					},
					{
						"label": "Hockey",
						"value": "5"
					}
				]
			},
			{
				"name": "ttId",
				"required": true,
				"picker": "tournament_picker",
				"data_type": "number",
				"label": "Tournament Id",
				"values": [
					{
						"label": "Any",
						"value": "*"
					},
					{
						"label": "ALKA Superliga",
						"value": "46"
					},
					{
						"label": "Premier League",
						"value": "47"
					},
					{
						"label": "Spain Primera",
						"value": "87"
					},
					{
						"label": "Bundesliga",
						"value": "54"
					},
					{
						"label": "UEFA Champions League",
						"value": "42"
					},
					{
						"label": "UEFA Europa League",
						"value": "73"
					},
					{
						"label": "Sweden Allsvenskan",
						"value": "67"
					},
					{
						"label": "Norway Eliteserien",
						"value": "59"
					}
				]
			},
			{
				"name": "eventId",
				"label": "Event ID",
				"picker": "event_by_date_picker",
				"data_type": "number"
			},
			{
				"name": "homeId",
				"picker": "team_picker",
				"data_type": "number",
				"label": "Home team Id"
			},
			{
				"name": "awayId",
				"picker": "team_picker",
				"data_type": "number",
				"label": "Away team Id"
			},
			{
				"name": "status",
				"label": "Status",
				"picker": "enum_picker",
				"data_type": "enum",
				"values": [
					{
						"label": "Any",
						"value": "*"
					},
					{
						"label": "Match started",
						"value": "1st_half"
					},
					{
						"label": "Halftime",
						"value": "halftime"
					},
					{
						"label": "2nd half started",
						"value": "2nd_half"
					},
					{
						"label": "Extra Time - 1st half",
						"value": "et_1st_half"
					},
					{
						"label": "Extra Time - 2nd half",
						"value": "et_2nd_half"
					},
					{
						"label": "Penalty",
						"value": "penalty"
					},
					{
						"label": "Finished",
						"value": "finished"
					}
				]
			}
		]
	},
	{
		"trigger": "enet_event_match_day",
		"conditions": [
			{
				"name": "sportId",
				"picker": "enum_picker",
				"data_type": "number",
				"label": "Sport",
				"values": [
					{
						"label": "Any",
						"value": "*"
					},
					{
						"label": "Soccer",
						"value": "1"
					},
					{
						"label": "Handball",
						"value": "20"
					},
					{
						"label": "Basket",
						"value": "23"
					},
					{
						"label": "Tennis",
						"value": "2"
					},
					{
						"label": "Hockey",
						"value": "5"
					}
				]
			},
			{
				"name": "ttId",
				"required": true,
				"picker": "tournament_picker",
				"data_type": "number",
				"label": "Tournament Id",
				"values": [
					{
						"label": "Any",
						"value": "*"
					},
					{
						"label": "ALKA Superliga",
						"value": "46"
					},
					{
						"label": "Premier League",
						"value": "47"
					},
					{
						"label": "Spain Primera",
						"value": "87"
					},
					{
						"label": "Bundesliga",
						"value": "54"
					},
					{
						"label": "UEFA Champions League",
						"value": "42"
					},
					{
						"label": "UEFA Europa League",
						"value": "73"
					},
					{
						"label": "Sweden Allsvenskan",
						"value": "67"
					},
					{
						"label": "Norway Eliteserien",
						"value": "59"
					}
				]
			},
			{
				"name": "eventId",
				"label": "Event ID",
				"picker": "event_by_date_picker",
				"data_type": "number"
			},
			{
				"name": "homeId",
				"picker": "team_picker",
				"data_type": "number",
				"label": "Home team Id"
			},
			{
				"name": "awayId",
				"picker": "team_picker",
				"data_type": "number",
				"label": "Away team Id"
			}
		]
	},
	{
		"trigger": "schedule",
		"conditions": [
			{
				"name": "time",
				"label": "Time",
				"picker": "time_picker",
				"data_type": "time",
				"required": true
			}
		]
	},
	{
		"trigger": "time",
		"conditions": [
			{
				"name": "dateTime",
				"label": "Date time",
				"picker": "dateTime_picker",
				"data_type": "dateTime",
				"required": true
			}
		]
	},
	{
		"trigger": "enet_event_live_minute",
		"conditions": [
			{
				"name": "sportId",
				"picker": "enum_picker",
				"data_type": "number",
				"label": "Sport",
				"values": [
					{
						"label": "Any",
						"value": "*"
					},
					{
						"label": "Soccer",
						"value": "1"
					},
					{
						"label": "Handball",
						"value": "20"
					},
					{
						"label": "Basket",
						"value": "23"
					},
					{
						"label": "Tennis",
						"value": "2"
					},
					{
						"label": "Hockey",
						"value": "5"
					}
				]
			},
			{
				"name": "ttId",
				"required": true,
				"picker": "tournament_picker",
				"data_type": "number",
				"label": "Tournament Id",
				"values": [
					{
						"label": "Any",
						"value": "*"
					},
					{
						"label": "ALKA Superliga",
						"value": "46"
					},
					{
						"label": "Premier League",
						"value": "47"
					},
					{
						"label": "Spain Primera",
						"value": "87"
					},
					{
						"label": "Bundesliga",
						"value": "54"
					},
					{
						"label": "UEFA Champions League",
						"value": "42"
					},
					{
						"label": "UEFA Europa League",
						"value": "73"
					},
					{
						"label": "Sweden Allsvenskan",
						"value": "67"
					},
					{
						"label": "Norway Eliteserien",
						"value": "59"
					}
				]
			},
			{
				"name": "eventId",
				"label": "Event ID",
				"picker": "event_by_date_picker",
				"data_type": "number"
			},
			{
				"name": "homeId",
				"picker": "team_picker",
				"data_type": "number",
				"label": "Home team Id"
			},
			{
				"name": "awayId",
				"picker": "team_picker",
				"data_type": "number",
				"label": "Away team Id"
			},
			{
				"name": "minutes",
				"label": "Minutes",
				"picker": "number_picker",
				"data_type": "number"
			}
		]
	},
	{
		"trigger": "enet_event_lineup_confirmed",
		"conditions": [
			{
				"name": "sportId",
				"picker": "enum_picker",
				"data_type": "number",
				"label": "Sport",
				"values": [
					{
						"label": "Any",
						"value": "*"
					},
					{
						"label": "Soccer",
						"value": "1"
					},
					{
						"label": "Handball",
						"value": "20"
					},
					{
						"label": "Basket",
						"value": "23"
					},
					{
						"label": "Tennis",
						"value": "2"
					},
					{
						"label": "Hockey",
						"value": "5"
					}
				]
			},
			{
				"name": "ttId",
				"required": true,
				"picker": "tournament_picker",
				"data_type": "number",
				"label": "Tournament Id",
				"values": [
					{
						"label": "Any",
						"value": "*"
					},
					{
						"label": "ALKA Superliga",
						"value": "46"
					},
					{
						"label": "Premier League",
						"value": "47"
					},
					{
						"label": "Spain Primera",
						"value": "87"
					},
					{
						"label": "Bundesliga",
						"value": "54"
					},
					{
						"label": "UEFA Champions League",
						"value": "42"
					},
					{
						"label": "UEFA Europa League",
						"value": "73"
					},
					{
						"label": "Sweden Allsvenskan",
						"value": "67"
					},
					{
						"label": "Norway Eliteserien",
						"value": "59"
					}
				]
			},
			{
				"name": "eventId",
				"label": "Event ID",
				"picker": "event_by_date_picker",
				"data_type": "number"
			},
			{
				"name": "homeId",
				"picker": "team_picker",
				"data_type": "number",
				"label": "Home team Id"
			},
			{
				"name": "awayId",
				"picker": "team_picker",
				"data_type": "number",
				"label": "Away team Id"
			},
			{
				"name": "incident_type",
				"picker": "enum_picker",
				"data_type": "enum",
				"label": "type",
				"values": [
					{
						"label": "Confirmed",
						"value": "confirmed"
					}
				]
			}
		]
	},
	{
		"trigger": "tourn_match_day",
		"conditions": [
			{
				"name": "sportId",
				"picker": "enum_picker",
				"data_type": "number",
				"label": "Sport",
				"values": [
					{
						"label": "Any",
						"value": "*"
					},
					{
						"label": "Soccer",
						"value": "1"
					},
					{
						"label": "Handball",
						"value": "20"
					},
					{
						"label": "Basket",
						"value": "23"
					},
					{
						"label": "Tennis",
						"value": "2"
					},
					{
						"label": "Hockey",
						"value": "5"
					}
				]
			},
			{
				"name": "ttId",
				"required": true,
				"picker": "tournament_picker",
				"data_type": "number",
				"label": "Tournament Id",
				"values": [
					{
						"label": "Any",
						"value": "*"
					},
					{
						"label": "ALKA Superliga",
						"value": "46"
					},
					{
						"label": "Premier League",
						"value": "47"
					},
					{
						"label": "Spain Primera",
						"value": "87"
					},
					{
						"label": "Bundesliga",
						"value": "54"
					},
					{
						"label": "UEFA Champions League",
						"value": "42"
					},
					{
						"label": "UEFA Europa League",
						"value": "73"
					},
					{
						"label": "Sweden Allsvenskan",
						"value": "67"
					},
					{
						"label": "Norway Eliteserien",
						"value": "59"
					}
				]
			},
			{
				"name": "time",
				"label": "Time",
				"picker": "time_picker",
				"data_type": "time",
				"required": true
			}
		]
	},
	{
		"trigger": "event_days_before_at",
		"conditions": [
			{
				"name": "sportId",
				"picker": "enum_picker",
				"data_type": "number",
				"label": "Sport",
				"values": [
					{
						"label": "Any",
						"value": "*"
					},
					{
						"label": "Soccer",
						"value": "1"
					},
					{
						"label": "Handball",
						"value": "20"
					},
					{
						"label": "Basket",
						"value": "23"
					},
					{
						"label": "Tennis",
						"value": "2"
					},
					{
						"label": "Hockey",
						"value": "5"
					}
				]
			},
			{
				"name": "ttId",
				"required": true,
				"picker": "tournament_picker",
				"data_type": "number",
				"label": "Tournament Id",
				"values": [
					{
						"label": "Any",
						"value": "*"
					},
					{
						"label": "ALKA Superliga",
						"value": "46"
					},
					{
						"label": "Premier League",
						"value": "47"
					},
					{
						"label": "Spain Primera",
						"value": "87"
					},
					{
						"label": "Bundesliga",
						"value": "54"
					},
					{
						"label": "UEFA Champions League",
						"value": "42"
					},
					{
						"label": "UEFA Europa League",
						"value": "73"
					},
					{
						"label": "Sweden Allsvenskan",
						"value": "67"
					},
					{
						"label": "Norway Eliteserien",
						"value": "59"
					}
				]
			},
			{
				"name": "eventId",
				"label": "Event ID",
				"picker": "event_by_date_picker",
				"data_type": "number"
			},
			{
				"name": "days",
				"label": "Days",
				"picker": "number_picker",
				"data_type": "number"
			},
			{
				"name": "time",
				"label": "Time",
				"picker": "time_picker",
				"data_type": "time",
				"required": true
			}
		]
	},
	{
		"trigger": "event_hours_before",
		"conditions": [
			{
				"name": "sportId",
				"picker": "enum_picker",
				"data_type": "number",
				"label": "Sport",
				"values": [
					{
						"label": "Any",
						"value": "*"
					},
					{
						"label": "Soccer",
						"value": "1"
					},
					{
						"label": "Handball",
						"value": "20"
					},
					{
						"label": "Basket",
						"value": "23"
					},
					{
						"label": "Tennis",
						"value": "2"
					},
					{
						"label": "Hockey",
						"value": "5"
					}
				]
			},
			{
				"name": "ttId",
				"required": true,
				"picker": "tournament_picker",
				"data_type": "number",
				"label": "Tournament Id",
				"values": [
					{
						"label": "Any",
						"value": "*"
					},
					{
						"label": "ALKA Superliga",
						"value": "46"
					},
					{
						"label": "Premier League",
						"value": "47"
					},
					{
						"label": "Spain Primera",
						"value": "87"
					},
					{
						"label": "Bundesliga",
						"value": "54"
					},
					{
						"label": "UEFA Champions League",
						"value": "42"
					},
					{
						"label": "UEFA Europa League",
						"value": "73"
					},
					{
						"label": "Sweden Allsvenskan",
						"value": "67"
					},
					{
						"label": "Norway Eliteserien",
						"value": "59"
					}
				]
			},
			{
				"name": "eventId",
				"label": "Event ID",
				"picker": "event_by_date_picker",
				"data_type": "number"
			},
			{
				"name": "hours",
				"label": "Hours",
				"picker": "number_picker",
				"data_type": "number"
			}
		]
	},
	{
		"trigger": "tourn_round_starts",
		"conditions": [
			{
				"name": "sportId",
				"picker": "enum_picker",
				"data_type": "number",
				"label": "Sport",
				"values": [
					{
						"label": "Any",
						"value": "*"
					},
					{
						"label": "Soccer",
						"value": "1"
					},
					{
						"label": "Handball",
						"value": "20"
					},
					{
						"label": "Basket",
						"value": "23"
					},
					{
						"label": "Tennis",
						"value": "2"
					},
					{
						"label": "Hockey",
						"value": "5"
					}
				]
			},
			{
				"name": "ttId",
				"required": true,
				"picker": "tournament_picker",
				"data_type": "number",
				"label": "Tournament Id",
				"values": [
					{
						"label": "Any",
						"value": "*"
					},
					{
						"label": "ALKA Superliga",
						"value": "46"
					},
					{
						"label": "Premier League",
						"value": "47"
					},
					{
						"label": "Spain Primera",
						"value": "87"
					},
					{
						"label": "Bundesliga",
						"value": "54"
					},
					{
						"label": "UEFA Champions League",
						"value": "42"
					},
					{
						"label": "UEFA Europa League",
						"value": "73"
					},
					{
						"label": "Sweden Allsvenskan",
						"value": "67"
					},
					{
						"label": "Norway Eliteserien",
						"value": "59"
					}
				]
			},
			{
				"name": "round",
				"label": "Round",
				"picker": "round_picker",
				"data_type": "string"
			},
			{
				"name": "time",
				"label": "Time",
				"picker": "time_picker",
				"data_type": "time",
				"required": true
			}
		]
	},
	{
		"trigger": "tourn_round_ends",
		"conditions": [
			{
				"name": "sportId",
				"picker": "enum_picker",
				"data_type": "number",
				"label": "Sport",
				"values": [
					{
						"label": "Any",
						"value": "*"
					},
					{
						"label": "Soccer",
						"value": "1"
					},
					{
						"label": "Handball",
						"value": "20"
					},
					{
						"label": "Basket",
						"value": "23"
					},
					{
						"label": "Tennis",
						"value": "2"
					},
					{
						"label": "Hockey",
						"value": "5"
					}
				]
			},
			{
				"name": "ttId",
				"required": true,
				"picker": "tournament_picker",
				"data_type": "number",
				"label": "Tournament Id",
				"values": [
					{
						"label": "Any",
						"value": "*"
					},
					{
						"label": "ALKA Superliga",
						"value": "46"
					},
					{
						"label": "Premier League",
						"value": "47"
					},
					{
						"label": "Spain Primera",
						"value": "87"
					},
					{
						"label": "Bundesliga",
						"value": "54"
					},
					{
						"label": "UEFA Champions League",
						"value": "42"
					},
					{
						"label": "UEFA Europa League",
						"value": "73"
					},
					{
						"label": "Sweden Allsvenskan",
						"value": "67"
					},
					{
						"label": "Norway Eliteserien",
						"value": "59"
					}
				]
			},
			{
				"name": "round",
				"label": "Round",
				"picker": "round_picker",
				"data_type": "string"
			},
			{
				"name": "time",
				"label": "Time",
				"picker": "time_picker",
				"data_type": "time",
				"required": true
			}
		]
	},
	{
		"trigger": "event_starts",
		"conditions": [
			{
				"name": "sportId",
				"picker": "enum_picker",
				"data_type": "number",
				"label": "Sport",
				"values": [
					{
						"label": "Any",
						"value": "*"
					},
					{
						"label": "Soccer",
						"value": "1"
					},
					{
						"label": "Handball",
						"value": "20"
					},
					{
						"label": "Basket",
						"value": "23"
					},
					{
						"label": "Tennis",
						"value": "2"
					},
					{
						"label": "Hockey",
						"value": "5"
					}
				]
			},
			{
				"name": "ttId",
				"required": true,
				"picker": "tournament_picker",
				"data_type": "number",
				"label": "Tournament Id",
				"values": [
					{
						"label": "Any",
						"value": "*"
					},
					{
						"label": "ALKA Superliga",
						"value": "46"
					},
					{
						"label": "Premier League",
						"value": "47"
					},
					{
						"label": "Spain Primera",
						"value": "87"
					},
					{
						"label": "Bundesliga",
						"value": "54"
					},
					{
						"label": "UEFA Champions League",
						"value": "42"
					},
					{
						"label": "UEFA Europa League",
						"value": "73"
					},
					{
						"label": "Sweden Allsvenskan",
						"value": "67"
					},
					{
						"label": "Norway Eliteserien",
						"value": "59"
					}
				]
			},
			{
				"name": "eventId",
				"label": "Event ID",
				"picker": "event_by_date_picker",
				"data_type": "number"
			},
			{
				"name": "minutes",
				"label": "Minutes",
				"picker": "number_picker",
				"data_type": "number"
			}
		]
	},
	{
		"trigger": "event_halftime",
		"conditions": [
			{
				"name": "sportId",
				"picker": "enum_picker",
				"data_type": "number",
				"label": "Sport",
				"values": [
					{
						"label": "Any",
						"value": "*"
					},
					{
						"label": "Soccer",
						"value": "1"
					},
					{
						"label": "Handball",
						"value": "20"
					},
					{
						"label": "Basket",
						"value": "23"
					},
					{
						"label": "Tennis",
						"value": "2"
					},
					{
						"label": "Hockey",
						"value": "5"
					}
				]
			},
			{
				"name": "ttId",
				"required": true,
				"picker": "tournament_picker",
				"data_type": "number",
				"label": "Tournament Id",
				"values": [
					{
						"label": "Any",
						"value": "*"
					},
					{
						"label": "ALKA Superliga",
						"value": "46"
					},
					{
						"label": "Premier League",
						"value": "47"
					},
					{
						"label": "Spain Primera",
						"value": "87"
					},
					{
						"label": "Bundesliga",
						"value": "54"
					},
					{
						"label": "UEFA Champions League",
						"value": "42"
					},
					{
						"label": "UEFA Europa League",
						"value": "73"
					},
					{
						"label": "Sweden Allsvenskan",
						"value": "67"
					},
					{
						"label": "Norway Eliteserien",
						"value": "59"
					}
				]
			},
			{
				"name": "eventId",
				"label": "Event ID",
				"picker": "event_by_date_picker",
				"data_type": "number"
			},
			{
				"name": "minutes",
				"label": "Minutes",
				"picker": "number_picker",
				"data_type": "number"
			}
		]
	},
	{
		"trigger": "event_finished",
		"conditions": [
			{
				"name": "sportId",
				"picker": "enum_picker",
				"data_type": "number",
				"label": "Sport",
				"values": [
					{
						"label": "Any",
						"value": "*"
					},
					{
						"label": "Soccer",
						"value": "1"
					},
					{
						"label": "Handball",
						"value": "20"
					},
					{
						"label": "Basket",
						"value": "23"
					},
					{
						"label": "Tennis",
						"value": "2"
					},
					{
						"label": "Hockey",
						"value": "5"
					}
				]
			},
			{
				"name": "ttId",
				"required": true,
				"picker": "tournament_picker",
				"data_type": "number",
				"label": "Tournament Id",
				"values": [
					{
						"label": "Any",
						"value": "*"
					},
					{
						"label": "ALKA Superliga",
						"value": "46"
					},
					{
						"label": "Premier League",
						"value": "47"
					},
					{
						"label": "Spain Primera",
						"value": "87"
					},
					{
						"label": "Bundesliga",
						"value": "54"
					},
					{
						"label": "UEFA Champions League",
						"value": "42"
					},
					{
						"label": "UEFA Europa League",
						"value": "73"
					},
					{
						"label": "Sweden Allsvenskan",
						"value": "67"
					},
					{
						"label": "Norway Eliteserien",
						"value": "59"
					}
				]
			},
			{
				"name": "eventId",
				"label": "Event ID",
				"picker": "event_by_date_picker",
				"data_type": "number"
			},
			{
				"name": "minutes",
				"label": "Minutes",
				"picker": "number_picker",
				"data_type": "number"
			}
		]
	},
	{
		"trigger": "transfer",
		"conditions": [
			{
				"name": "type",
				"picker": "enum_picker",
				"data_type": "string",
				"label": "Type",
				"values": [
					{
						"label": "Any",
						"value": "*"
					},
					{
						"label": "Transfer/confirmed",
						"value": "transfer"
					},
					{
						"label": "Rumour",
						"value": "rumour"
					}
				]
			},
			{
				"name": "fromTTId",
				"picker": "tournament_picker",
				"data_type": "number",
				"label": "From Tournament",
				"values": [
					{
						"label": "Any",
						"value": "*"
					},
					{
						"label": "ALKA Superliga",
						"value": "46"
					},
					{
						"label": "Premier League",
						"value": "47"
					},
					{
						"label": "Spain Primera",
						"value": "87"
					},
					{
						"label": "Bundesliga",
						"value": "54"
					},
					{
						"label": "UEFA Champions League",
						"value": "42"
					},
					{
						"label": "UEFA Europa League",
						"value": "73"
					},
					{
						"label": "Sweden Allsvenskan",
						"value": "67"
					},
					{
						"label": "Norway Eliteserien",
						"value": "59"
					}
				]
			},
			{
				"name": "toTTId",
				"picker": "tournament_picker",
				"data_type": "number",
				"label": "To Tournament",
				"values": [
					{
						"label": "Any",
						"value": "*"
					},
					{
						"label": "ALKA Superliga",
						"value": "46"
					},
					{
						"label": "Premier League",
						"value": "47"
					},
					{
						"label": "Spain Primera",
						"value": "87"
					},
					{
						"label": "Bundesliga",
						"value": "54"
					},
					{
						"label": "UEFA Champions League",
						"value": "42"
					},
					{
						"label": "UEFA Europa League",
						"value": "73"
					},
					{
						"label": "Sweden Allsvenskan",
						"value": "67"
					},
					{
						"label": "Norway Eliteserien",
						"value": "59"
					}
				]
			},
			{
				"name": "fromTeamId",
				"picker": "team_picker",
				"data_type": "number",
				"label": "From team Id"
			},
			{
				"name": "toTeamId",
				"picker": "team_picker",
				"data_type": "number",
				"label": "To team Id"
			},
			{
				"name": "playerId",
				"picker": "player_picker",
				"data_type": "number",
				"label": "Player id"
			}
		]
	},
	{
		"trigger": "event_test",
		"conditions": [
			{
				"name": "sportId",
				"picker": "enum_picker",
				"data_type": "number",
				"label": "Sport",
				"values": [
					{
						"label": "Any",
						"value": "*"
					},
					{
						"label": "Soccer",
						"value": "1"
					},
					{
						"label": "Handball",
						"value": "20"
					},
					{
						"label": "Basket",
						"value": "23"
					},
					{
						"label": "Tennis",
						"value": "2"
					},
					{
						"label": "Hockey",
						"value": "5"
					}
				]
			},
			{
				"name": "ttId",
				"required": true,
				"picker": "tournament_picker",
				"data_type": "number",
				"label": "Tournament Id",
				"values": [
					{
						"label": "Any",
						"value": "*"
					},
					{
						"label": "ALKA Superliga",
						"value": "46"
					},
					{
						"label": "Premier League",
						"value": "47"
					},
					{
						"label": "Spain Primera",
						"value": "87"
					},
					{
						"label": "Bundesliga",
						"value": "54"
					},
					{
						"label": "UEFA Champions League",
						"value": "42"
					},
					{
						"label": "UEFA Europa League",
						"value": "73"
					},
					{
						"label": "Sweden Allsvenskan",
						"value": "67"
					},
					{
						"label": "Norway Eliteserien",
						"value": "59"
					}
				]
			},
			{
				"name": "eventId",
				"label": "Event ID",
				"picker": "event_by_date_picker",
				"data_type": "number"
			},
			{
				"name": "minutes",
				"label": "Minutes",
				"picker": "number_picker",
				"data_type": "number"
			}
		]
	}
];


/*****************
 ** WEBPACK FOOTER
 ** ../src/config/triggerTypes.json
 ** module id = 1838
 ** module chunks = 0
 **/